import React from "react";
import ModalIndex from "@Modals/layout/index";
import { TextArea } from "@components/tailwindComponents";

export default React.memo(function NewRequest({
  onClickClose,
  show,
  commentReceived,
  commentSended,
  statusTitle,
  t
}) {
  return (
    <ModalIndex
      isOpen={show}
      onClickClose={onClickClose}
      customTitle={
        <h3 className="arh-text-xl arh-mt-8 arh-font-poppins arh-text-black arh-font-semibold arh-text-center">
          {t("Démande")} <span className="arh-lowercase">{t(statusTitle)}</span>
        </h3>
      }
      buttonType="none"
    >
      <div className="arh-space-y-4">
        <TextArea
          label={t("Commentaire reçu")}
          value={commentReceived}
          disabled
        />
        <TextArea
          label={t("Commentaire envoyé")}
          value={commentSended}
          disabled
        />
      </div>
    </ModalIndex>
  );
});
